import React, { type FunctionComponent } from 'react'
import { Table } from 'legacy/dash-components/table/Table'
import { useGeneratedReportsTableContent } from 'legacy/sections/generated-reports/components/list/utils/tableContent.hooks'
import { type UseListReportRequestsPayload } from 'legacy/sections/generated-reports/graphql/list.hooks'
import { type UseReportViewDownloadBehaviour } from 'legacy/sections/generated-reports/graphql/reportViewDownloadUrl.hooks'

interface Props
  extends Omit<UseListReportRequestsPayload, 'called'>,
    UseReportViewDownloadBehaviour {}

export const GeneratedReportsListTable: FunctionComponent<Props> = ({
  reportRequests,
  totalCount,
  fetchReportRequests,
  downloadReportView,
  ...rest
}) => {
  const tableContent = useGeneratedReportsTableContent({ downloadReportView })

  return (
    <Table
      {...tableContent}
      {...rest}
      testId="generated-reports-list-table"
      totalRecordCount={totalCount}
      data={reportRequests}
      fetchData={fetchReportRequests}
      manualPagination
      tableWrapperOverrideStyle={{ borderTop: 'none' }}
      filters={undefined}
    />
  )
}
